export default __webpack_public_path__ + "static/assets/637d8e3d86c55bab69e48c079d33fc07.png";